export enum FormElementsTypes {
  SEARCH = 'SEARCH',
  DROPDOWN = 'DROPDOWN',
  MULTISELECT = 'MULTISELECT',
  TEXTAREA = 'TEXTAREA',
  CHECK = 'CHECK'
}
